/**
 * ConfigureStep — step 1 of the ABR filter form dialog.
 * Provides inputs for filter name, description, and source toggle.
 */

import { Heading, Switch, Text, TextInput } from '@soteria/design-system-ve';

import * as styles from './AbrFilterFormDialog.css';

export interface ConfigureStepProps {
  name: string;
  description: string;
  reportedContent: boolean;
  onNameChange: (v: string) => void;
  onDescriptionChange: (v: string) => void;
  onToggleSource: () => void;
}

export function ConfigureStep({ name, description, reportedContent, onNameChange, onDescriptionChange, onToggleSource }: ConfigureStepProps) {
  return (
    <div className={styles.stepContentStyles}>
      <div className={styles.fieldGroupStyles}>
        <Text className={styles.fieldLabelStyles}>Filter Name</Text>
        <TextInput aria-label="Filter name" maxLength={100} placeholder="e.g., Reported Content Only" value={name} onChange={onNameChange} />
      </div>

      <div className={styles.fieldGroupStyles}>
        <Text className={styles.fieldLabelStyles}>Description (optional)</Text>
        <TextInput aria-label="Description" placeholder="Describe what this filter does" value={description} onChange={onDescriptionChange} />
      </div>

      <div className={styles.fieldGroupStyles}>
        <Text className={styles.fieldLabelStyles}>Source</Text>
        <div className={styles.toggleRowStyles}>
          <Switch aria-label="Source filter" checked={reportedContent} onChange={onToggleSource} />
          <div>
            <Heading level="h3">{reportedContent ? 'Reported content' : 'Classified content'}</Heading>
            <Text className={styles.toggleDescriptionStyles}>
              {reportedContent
                ? 'Only cases originating from user reports will match this filter.'
                : 'Only cases originating from automated classification will match this filter.'}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
